import React, { useEffect, useState } from 'react';

import styles from './last-note.module.scss';
import { getLastNote } from '../../services/api/note';
import { NotesResult } from '../../interfaces/note-result';
import { AxiosResponse } from 'axios';
import moment from 'moment';
import { NoteModal } from '../note-modal/note-modal';
import { NewNoteModal } from '../new-note-modal/new-note-modal';
import { Tooltip } from '../common/tooltip';

export const LastNotePanel = ({ patient }: { patient: any }) => {
  const [lastNote, setLastNote] = useState<any>(null);
  const [viewNote, setViewNote] = useState(false);
  const [addNote, setAddNote] = useState(false);

  useEffect(() => {
    if (!patient) {
      return;
    }
    getLastNote(patient.id).then(({ data }: AxiosResponse<NotesResult>) => {
      if (data?.size > 0) {
        setLastNote(data.values[0]);
      }
    });
  }, [patient]);

  return (
    <>
      <div className={styles.card}>
        <div className={styles.top}>
          <span className={styles.title}>LAST NOTE</span>
          <Tooltip baseStyles={styles.infoTooltip} type='left' background='#F5F6FA'>
            <div className={styles.hoverText}>This is the last note generated by a practitioner about this client.</div>
          </Tooltip>
        </div>
        <div className={styles.middle}>
          {lastNote !== null && (
            <div className={styles.note}>
              <span className={styles.title}>{lastNote.title}</span>
              <span className={styles.summary}>{lastNote.summary}</span>
              <span className={styles.readMore} onClick={() => setViewNote(true)}>
                READ MORE
              </span>
            </div>
          )}
          {lastNote === null && (
            <div className={styles.noNote}>
              <svg width='32' height='46' viewBox='0 0 32 46' fill='none' xmlns='http://www.w3.org/2000/svg'>
                <path
                  fillRule='evenodd'
                  clipRule='evenodd'
                  d='M25.7391 6.27273H29.9089C31.0661 6.27273 32 7.20469 32 8.36802V43.9047C32 45.0616 31.0636 46 29.9096 46H2.09037C0.933521 46 0 45.068 0 43.9047V8.36802C0 7.20868 0.930307 6.27273 2.09108 6.27273H6.26087V4.87879C6.26087 3.72268 7.19049 2.78788 8.34651 2.78788H12.0229C12.163 2.44714 12.3704 2.06084 12.6609 1.67274C13.4369 0.636058 14.5479 0 16 0C17.4521 0 18.5631 0.636058 19.3391 1.67274C19.6296 2.06084 19.837 2.44714 19.9771 2.78788H23.6535C24.8069 2.78788 25.7391 3.72023 25.7391 4.87879V6.27273ZM7.65217 4.87879V9.06205C7.65217 9.44473 7.96387 9.75758 8.34575 9.75758H23.6543C24.0369 9.75758 24.3478 9.44598 24.3478 9.06205V4.87879C24.3478 4.49062 24.0391 4.18182 23.6535 4.18182H19.4783C19.159 4.18182 18.8808 3.96417 18.8034 3.6539C18.7896 3.59882 18.7512 3.47909 18.684 3.31733C18.569 3.04103 18.4172 2.76431 18.2261 2.50907C17.6978 1.80334 16.9827 1.39394 16 1.39394C15.0173 1.39394 14.3022 1.80334 13.7739 2.50907C13.5828 2.76431 13.431 3.04103 13.316 3.31733C13.2488 3.47909 13.2104 3.59882 13.1966 3.6539C13.1192 3.96417 12.841 4.18182 12.5217 4.18182H8.34651C7.96003 4.18182 7.65217 4.49139 7.65217 4.87879ZM6.26087 7.66667H2.09108C1.70001 7.66667 1.3913 7.97723 1.3913 8.36802V43.9047C1.3913 44.297 1.70084 44.6061 2.09037 44.6061H29.9096C30.2951 44.6061 30.6087 44.2918 30.6087 43.9047V8.36802C30.6087 7.97578 30.2989 7.66667 29.9089 7.66667H25.7391V9.06205C25.7391 10.2158 24.8053 11.1515 23.6543 11.1515H8.34575C7.19493 11.1515 6.26087 10.214 6.26087 9.06205V7.66667ZM25.0401 34.8485C25.4243 34.8485 25.7357 35.1605 25.7357 35.5455C25.7357 35.9304 25.4243 36.2424 25.0401 36.2424H7.07804C6.69385 36.2424 6.38239 35.9304 6.38239 35.5455C6.38239 35.1605 6.69385 34.8485 7.07804 34.8485H25.0401ZM25.0366 18.1212C25.4208 18.1212 25.7323 18.4333 25.7323 18.8182C25.7323 19.2031 25.4208 19.5152 25.0366 19.5152H7.07463C6.69043 19.5152 6.37897 19.2031 6.37897 18.8182C6.37897 18.4333 6.69043 18.1212 7.07463 18.1212H25.0366ZM25.0401 26.4848C25.4243 26.4848 25.7357 26.7969 25.7357 27.1818C25.7357 27.5667 25.4243 27.8788 25.0401 27.8788H7.07804C6.69385 27.8788 6.38239 27.5667 6.38239 27.1818C6.38239 26.7969 6.69385 26.4848 7.07804 26.4848H25.0401Z'
                  fill='#A3A6B3'
                />
              </svg>
              <span className={styles.title}>No notes yet...</span>
              <span className={styles.details}>
                This patient has no notes yet, generate a new note by clicking the button below.
              </span>
            </div>
          )}
        </div>
        <div className={styles.bottom}>
          <div className={styles.left}>
            {lastNote?.id && (
              <>
                <span className={styles.label}>Note Generated:</span>
                <span className={styles.value}>{moment.utc(lastNote?.submittedTimestamp).local().format('lll')}</span>
                <span className={styles.label}>
                  Entry by:{' '}
                  <span className={styles.value}>
                    {lastNote.submittedByName.first} {lastNote.submittedByName.last}
                  </span>
                </span>
              </>
            )}
          </div>
          <div className={styles.right}>
            <button onClick={() => setAddNote(true)}>Generate Note</button>
          </div>
        </div>
      </div>
      {viewNote && <NoteModal onClose={() => setViewNote(false)} note={lastNote} patient={patient} />}
      {addNote && (
        <NewNoteModal
          onClose={res => {
            if (res) {
              setLastNote(res);
            }
            setAddNote(false);
          }}
          patient={patient}
          lastNote={lastNote}
        />
      )}
    </>
  );
};
